export const epanStatuses = [
  {
    id: '7dc67029-6862-46bc-9e07-457d57fd944d',
    index: 1,
    name: 'Created',
    slug: 'created'
  },
  {
    id: '97592006-2652-4a97-b6a0-1f5ded1b92b0',
    index: 2,
    name: 'Submitted',
    slug: 'submitted'
  },
  {
    id: 'c4a61771-59cb-42cc-bfda-8f213b0bd6a1',
    index: 3,
    name: 'Processed',
    slug: 'processed'
  },
  {
    id: 'd740ca0f-06cd-481b-a238-154bda326b61',
    index: 4,
    name: 'Withdrawn',
    slug: 'withdrawn'
  }
];
